import { render, staticRenderFns } from "./Form.input.number.vue?vue&type=template&id=2b104bd1"
import script from "./Form.input.number.vue?vue&type=script&lang=js"
export * from "./Form.input.number.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports